import { Log, Level, Logger } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import {
    ILoginSetCurrentPageAction,
    ILoginSetPageDataAction,
    ILoginFormResultAction,
    IMyForgotPasswordSetAction,
    IMyForgotPasswordQuestionAnswerSetAction,
    INewPasswordSetAction,
    IMyForgotPasswordSaveSetAction,
    ISetUserIdentity,
    ISetVerificateUserMail,
    ISetLoginFormData,
    ISetTwoFactorErrorMessage,
} from '../../models/action/login';
import { IGetChangeLanguage, ISetTimezoneValue, IUpdateProfilePhotoSet } from '../../models/action/profile';
import * as Actions from '../constants/all';
import { ILoginResultData } from '../../models/pages/login';
import { ErrorComponent, IError } from '../../models/core/system-model';
import { Common } from '../../core/common';

const _logger = Log.create('Login Reducer');
const common = new Common();

const setLoginPageData = (newState: any, pageData: any) => {
    newState.login.backgroundColor = pageData.backgroundColor;
    newState.login.backgroundPath = pageData.backgroundPath;
    newState.login.organizationLogo = pageData.organizationLogo;
    newState.login.footerText = pageData.footerText;
    newState.login.headerText = pageData.headerText;
    newState.login.logoPath = pageData.logoPath;
    newState.login.organizationId = pageData.organizationId;
    newState.login.organizationName = pageData.organizationName;
    newState.login.abbreviation = pageData.abbreviation;
    newState.login.trackingGuid = pageData.trackingGuid;
    newState.login.forgotMyPassword = pageData.forgotMyPassword;
    newState.login.forgotPasswordEnable = pageData.forgotPasswordEnable;
    newState.login.requiresQuestionAndAnswer = pageData.requiresQuestionAndAnswer;
    newState.login.forgotPasswordURLLink = pageData.forgotPasswordURLLink;
    newState.login.forgotPasswordUrlRecover = pageData.forgotPasswordUrlRecover;
    newState.login.headerBackgroundImage = pageData.headerBackgroundImage;
    newState.login.requisiteMinPasswordLength = !pageData.requisiteMinPasswordLength ? 1 : parseInt(pageData.requisiteMinPasswordLength);
    newState.login.minNonAlphanumericLength = !pageData.minNonAlphanumericLength ? 1 : parseInt(pageData.minNonAlphanumericLength);
    newState.login.forceChangePassword = pageData.forceChangePassword === 'true';
    newState.login.isAlmsPlusLoginPage = pageData.isAlmsPlusLoginPage;
    newState.login.googleCaptchaSiteKey = pageData.googleCaptchaSiteKey;
    newState.login.moduleItems = pageData.moduleItems;
    newState.login.isThereTwoFactorAuth = pageData.isThereTwoFactorAuthentication;
    if (pageData.defaultCulture) {
        newState.login.defaultCulture = pageData.defaultCulture;
    }
}

const setLoginResult = (newState: any, pageData: any) => {
    newState.identitiy.isLogin = pageData.isLogin;
    newState.identitiy.firstName = pageData.firstName;
    newState.identitiy.lastName = pageData.lastName;
    newState.identitiy.fullName = pageData.fullName;
    newState.identitiy.userName = pageData.userName;
    newState.identitiy.timeZone = pageData.timeZone;
    newState.identitiy.email = pageData.email;
    newState.identitiy.userType = pageData.userType;
    newState.identitiy.loginPermission = pageData.loginPermission;
    newState.identitiy.customLoginPermission = (pageData.customLoginPermission) ? pageData.customLoginPermission : [];
    newState.identitiy.userId = pageData.userId;
    newState.identitiy.clusterType = pageData.clusterType!;
    newState.identitiy.organizationId = pageData.organizationId!;
    newState.identitiy.profileImagePath = pageData.profileImagePath;
    newState.identitiy.forceChangePassword = pageData.forceChangePassword!;
    newState.identitiy.isSimulate = pageData.isSimulate;
    newState.identitiy.programName = pageData.programName;

    if (newState.loginCulture) {
        newState.identitiy.culture = newState.loginCulture;
        common.ChangeUserCulture(newState.loginCulture);

    } else {
        newState.identitiy.culture = pageData.culture;
        common.ChangeUserCulture(pageData.culture);

    }
}

const setForgotMyPassword = (newState: any, pageData: any, currentPageData: any) => {
    if (pageData) {
        newState.login.haveUser = pageData.haveUser;
        newState.login.isQuestion = pageData.isQuestion;
        newState.login.passwordSecurtiyQuestion = pageData.passwordSecurtiyQuestion;
        newState.login.currentPage = currentPageData;
        newState.identitiy.userName = pageData.userName;
        newState.login.recoveryPasswordToken = pageData.recoveryPasswordToken;
        newState.login.myForgotPasswordQuestionLoading = true;
        newState.login.myForgotPasswordAnswerStatus = false;

    }
}

const setUserCulture = (newState: any, language: any) => {
    if (language) {
        newState.identitiy.culture = language;
        newState.loginCulture = language;
        common.ChangeUserCulture(language);

    }
}

const setLanguage = (newState: any, language: any) => {
    if (language) {
        newState.identitiy.culture = language;
        common.ChangeUserCulture(language);
    }
}

const updateProfilePhoto = (newState: any, updateProfilePhotoData: any) => {
    if (updateProfilePhotoData.profilePhotoData.profilePhoto !== null) {
        newState.identitiy.profileImagePath = updateProfilePhotoData.profilePhotoData.profilePhoto;
    }
}

export const LoginReducer = (state = GlobalState().login, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = { ...state };
    if (action.type === Actions.loginActions.LOGIN_SETPAGEDATA) {
        const pageData = (action as ILoginSetPageDataAction).pageData;
        setLoginPageData(newState, pageData);
    } else if (action.type === Actions.loginActions.LOGIN_SETCURRENTPAGE) {
        const currentPageAction = action as ILoginSetCurrentPageAction;
        newState.login.currentPage = currentPageAction.currentPage;
        newState.login.recoveryPasswordToken = currentPageAction.recoveryPasswordToken;
    } else if (action.type === Actions.loginActions.LOGIN_RESULTLOGINCLICK) {
        const pageData = (action as ILoginFormResultAction).returnData as ILoginResultData;
        setLoginResult(newState, pageData);
    } else if (action.type === Actions.profileActions.USER_SET_LANGUAGE) {
        const payload = (action as IGetChangeLanguage);
        setLanguage(newState, payload?.lang);
    } else if (action.type === Actions.loginActions.SET_USE_TIMEZONE) {
        const timezonePageAction = (action as ISetTimezoneValue);
        newState.identitiy.timeZone = timezonePageAction.timezone;
    } else if (action.type === Actions.profileActions.SET_LOGIN_USER_CULTURE) {
        const payload = (action as IGetChangeLanguage);
        setUserCulture(newState, payload?.lang);
    } else if (action.type === Actions.loginActions.LOGIN_LOGOFF) {
        newState.identitiy.isLogin = false;
        newState.identitiy.loginLoading = false;
        newState.identitiy.userName = '';
        newState.identitiy.firstName = '';
        newState.identitiy.lastName = '';
        newState.identitiy.fullName = '';
        newState.identitiy.timeZone = "";
        newState.identitiy.email = '';
        newState.identitiy.userType = '';
        newState.identitiy.loginPermission = [];
        newState.identitiy.customLoginPermission = [];
        newState.identitiy.userId = 0;
        newState.identitiy.clusterType = '';
        newState.identitiy.organizationId = 0;
        newState.identitiy.profileImagePath = '';
        newState.login.currentPage = '';
        newState.loginCulture = '';
        newState.identitiy.forceChangePassword = false;
        newState.identitiy.isSimulate = false
    } else if (action.type === Actions.loginActions.LOGIN_MY_FORGOT_PASSWORD_SET) {
        const pageData = (action as IMyForgotPasswordSetAction).myForgotPasswordData;
        const currentPageData = (action as IMyForgotPasswordSetAction).currentPage;
        setForgotMyPassword(newState, pageData, currentPageData);
    } else if (action.type === Actions.loginActions.LOGIN_MY_FORGOT_PASSWORD_QUESTION_ANSWER_SET) {
        const pageData = (action as IMyForgotPasswordQuestionAnswerSetAction);
        newState.login.myForgotPasswordAnswerStatus = pageData.myForgotPasswordAnswerStatus;
    } else if (action.type === Actions.loginActions.LOGIN_RESET_PASSWORD_CHECK_TOKEN_SET) {
        const pageData = (action as INewPasswordSetAction);
        newState.login.currentPage = pageData.currentPage;
        newState.login.expiredToken = pageData.expiredToken;
        newState.login.newPasswordLoading = pageData.newPasswordLoading;
        newState.login.notFoundToken = pageData.notFoundToken;
        newState.login.alphaNumericLength = pageData.alphaNumericLength;
        newState.login.minPasswordLength = pageData.minPasswordLength;
        newState.login.passwordStrength = pageData.passwordStrength;
        newState.login.newPasswordSaveStatus = false;
    } else if (action.type === Actions.loginActions.LOGIN_RESET_PASSWORD_SAVE_SET) {
        const pageData = (action as IMyForgotPasswordSaveSetAction);
        newState.login.newPasswordSaveStatus = pageData.saveStatus;

    } else if (action.type === Actions.loginActions.LOGIN_SETUSERIDENTITY) {
        const pageData = (action as ISetUserIdentity);
        newState.identitiy.forceChangePassword = pageData.userIdentityData.forceChangePassword;
    } else if (action.type === Actions.profileActions.UPDATE_PROFILE_PHOTO_ACTION_SET) {
        const updateProfilePhotoData = (action as IUpdateProfilePhotoSet);
        updateProfilePhoto(newState, updateProfilePhotoData);
    } else if (action.type === Actions.loginActions.SET_VERIFICATE_USER_MAIL) {
        const setVerificateUserMailAction = (action as ISetVerificateUserMail);
        newState.login.twoFactorEmail = setVerificateUserMailAction.twoFactorAuthMailAddress;
    } else if (action.type === Actions.loginActions.SET_LOGIN_FORM_DATA) {
        const setLoginFormDataAction = (action as ISetLoginFormData);
        newState.loginData = setLoginFormDataAction.loginFormData;

    } else if (action.type === Actions.loginActions.SET_TWO_FACTOR_CODE_ERROR) {
        const setTwoFactorErrorMessageAction = (action as ISetTwoFactorErrorMessage);
        newState.twoFactorVerificationError = setTwoFactorErrorMessageAction.errorMessage;

    } else {
        return state;
    }
    // return state;
    return Object.assign({}, state, newState);
};
export default LoginReducer;
